import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { SORT_TYPES } from '@savgroup-front-common/constants/shared/sort';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  StockItem,
} from '@savgroup-front-common/types';
import { StockItemListRubric } from '@/domains/stocks';

const ENDPOINT = `${APIConfiguration.sparePart}search/stockItem`;

export interface StockItemFilter {
  name: string;
  facets: {
    included: boolean;
    name: string;
  }[];
}

export interface GetStockItemsArgs {
  page: number;
  pageSize: number;
  isDescending?: boolean;
  sort?: SORT_TYPES;
  query: string;
  filters?: StockItemFilter[];
}

interface GetStockItemsResponse {
  hitCount: number;
  hits: StockItem[];
  rubrics: StockItemListRubric[];
}

export const getStockItemsRequest = ({
  page,
  pageSize,
  isDescending,
  sort = SORT_TYPES.STOCK_INPUT_TIME_UTC,
  query,
  filters,
}: GetStockItemsArgs): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: {
    method: SUPPORTED_METHODS.POST,
    json: {
      page,
      pageSize,
      isDescending,
      sort,
      query,
      filters,
    },
  },
});

export default async function getStockItems(
  payload: GetStockItemsArgs,
): Promise<BackResponse<GetStockItemsResponse> | BackResponseFailure> {
  try {
    return await executeQuery<BackResponse<GetStockItemsResponse>>(
      getStockItemsRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
